import { typedBoolean } from "../helper";
export const transBreadcrumbSpecialCategory = (categories) => [...(categories || [])].map((i) => i.category).filter(typedBoolean);
